// Marca um `switch` como exaustivo: se um caso novo for adicionado ao tipo e
// esquecido no `switch`, o TypeScript passa a acusar erro aqui (o argumento
// deixa de ser `never`).

export function assertNunca(x: never): never {
  throw new Error(`Caso não tratado: ${JSON.stringify(x)}`);
}
